import { createContext } from 'react';
import { validatorManager } from './validatorManager';

/**
 * ValidatorContext provides shared validator registration and validation functions.
 *
 * This should be used anywhere input validation needs access to the central manager.
 */
export const ValidatorContext = createContext({
  registerInputValidator: validatorManager.registerInputValidator,
  getStepValidator: validatorManager.getStepValidator,
  getAllValidators: validatorManager.getAllValidators,
});
